import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	GetHealthAvailableTimes,
	GetHealthAvailableTimesModel,
	GetHealthAvailableTimesParams,
} from 'domain/usecases';

export class RemoteGetHealthAvailableTimes implements GetHealthAvailableTimes {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetHealthAvailableTimesModel>,
	) {}

	async get({
		signal,
		...params
	}: GetHealthAvailableTimesParams): Promise<GetHealthAvailableTimesModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
